/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 29/09/2020  
 */
const loginResponse = () => {
    return {
        access_token:null,
        expires_in: null,
        refresh_token: null,
        token_type: null,
        scope: null
    }

}

export default loginResponse;